import moment from 'moment';
import React, { Component } from 'react';
import { SizeMe } from 'react-sizeme';

/* Dynamic Dashboard */
import * as preference from '../../lib/components/Preference';
import { DynamicGridGenerator } from '../../lib/components/value/platform_value_grid';

/* Routes */
import { domainIsTenant as dit } from '../../routes/routes'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Download */
import fileDownload from 'js-file-download';

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, has } from 'iotera-base/json'
import { parseNav, buildCommandId, buildDownloadId } from '../../webservice/config';
import Result from 'iotera-base/result';

import Iframe from 'react-iframe'
import { SubViewHeader, SubViewHeaderWithTenantName } from '../../lib/components/subHeader';
import { toDate } from '../../lib/components/formatter';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const WKEY = 'DASHBOARD';
let wSelector = null;
let wBoundActions = null

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dummy: {},
      event: null,
      first: false,
      isFromChart: true,
    }
    this.resize = this.resize.bind(this);
    this.handleControl = this.handleControl.bind(this);
    this.handleDropdown = this.handleDropdown.bind(this);
    this.handleUploadCsv = this.handleUploadCsv.bind(this);
    this.handleControlCustom = this.handleControlCustom.bind(this);
    this.handleDropdownCustom = this.handleDropdownCustom.bind(this);
    this.handlePeriod = this.handlePeriod.bind(this);
    this.handlePeriodDate = this.handlePeriodDate.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleSelector = this.handleSelector.bind(this);
    this.handleSelectFirstItem = this.handleSelectFirstItem.bind(this);
    this.handleSelectedDeviceId = this.handleSelectedDeviceId.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.wcallback = this.wcallback.bind(this);
  }

  wcallback(_this) {
    const finish = function (id, result) {
      const _props = _this.props;
      const _state = _this.state
      let type = safeDeepGetWithType(_state, ['event'], '');
      if (type === 'control') {
        if (result.code === Result.HTTP.OK) {
          const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
          if (responseResult === Result.SUCCESS) {
            _props.showSingleNotification({ message: 'Kirim perintah berhasil', level: 'success' });
          } else {
            _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
          }
        } else if (result.code === Result.HTTP.BAD_REQUEST) {
          const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
          if (responseResult === Result.NETWORK_FAILURE) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (perangkat sedang offline)', level: 'error' });
          } else if (responseResult === Result.BUSY) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (perangkat sibuk)', level: 'error' });
          } else if (responseResult === Result.TIMEOUT) {
            _props.showSingleNotification({ message: 'Kirim perintah gagal (timeout)', level: 'error' });
          } else {
            _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
          }
        } else {
          _props.showSingleNotification({ message: 'Kirim perintah gagal', level: 'error' });
        }
      } else if (type === 'download') {
        if (result.code === Result.HTTP.OK) {
          let csvDataString = safeDeepGetWithType(result, ['body'], '');
          _props.showSingleNotification({ message: 'Download sedang dilakukan', level: 'info' });
          let now = moment().unix() * 1000;
          let nowString = toDate(now, 'YYYY-MM-DD_HH-mm')
          let idChart = id.substring(9, id.length)
          const isFromChart = safeDeepGetWithType(_state, ['isFromChart'], true);
          if (isFromChart) {
            return fileDownload(csvDataString, `Chart_${idChart}_${nowString}.csv`);
          }
          return fileDownload(csvDataString, `Data_${idChart}_${nowString}.csv`);
        }
      }
    }
    return ({
      finished: finish
    })
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    const wsKey = WKEY + '_' + navId;
    wBoundActions = buildWBoundActions(wsKey);
    wSelector = buildWSelector(wsKey);
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get dashboard
    _props.wInitRequestCall(
      {
        wparam: {
          ...domainIsTenant, path: '/fetch/web/d/' + navId,
          type: preference.WEBSERVICE_FETCH,
        },
        wcallback: {
          started: function (id) {
            _props.showLoading();
          },
          finished: function (id, result) {
            _props.hideLoading();
            if (result.code === Result.HTTP.OK) {
              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {
                const dashType = safeDeepGetWithType(result, ['body', 'conf_dashboard', 'type'], preference.DASHBOARD_BASIC);
                if (dashType === preference.DASHBOARD_EMBEDDED) {
                  return;
                }
                const navDashboard = safeDeepGetWithType(result, ['body', 'conf_dashboard', 'dashboard'], {});
                const confDashboard = safeDeepGetWithType(result, ['body', 'conf_dashboard', 'config'], {});
                let isEmbedded = false;
                let deepDashboard = navDashboard[Object.keys(navDashboard)[0]];
                const cat = safeDeepGetWithType(deepDashboard, ['cat'], '');
                if (cat === preference.TYPE_EMBEDDED) {
                  isEmbedded = true;
                }
                if (!isEmbedded) {
                  const parseResult = parseNav(domainIsTenant, navId, navDashboard, _this.wcallback(_this), confDashboard);
                  if (!isNone(parseResult)) {
                    let initConf = parseResult['refresh_data'];
                    let singleConf = parseResult['single_config'];
                    const backgroundConfig = parseResult['background_config'];
                    const monitoringKeys = parseResult['is_monitoring'];
                    // Parse error
                    for (let key in backgroundConfig) {
                      backgroundConfig[key]['wreducer'] =
                      {
                        rparse: function (id, result, rpayload) {
                          let item = {}
                          const dashboard = rpayload
                          item = dashboard
                          item['error'] = safeDeepGet(dashboard, ['response_result'])
                          return item;
                        }
                      }
                      if (has(monitoringKeys, key)) {
                        let selectedType = preference.FILTER_CUSTOM;
                        let selectedName = 'default';
                        let first = true;
                        if (has(navDashboard, key)) {
                          let filter = safeDeepGetWithType(navDashboard, [key, "model", "filter"], {})
                          if (!isEmpty(filter)) {
                            for (let filterKey in filter) {
                              const type = safeDeepGetWithType(filter, [filterKey, 'type'], preference.FILTER_PERIOD);
                              if (type !== preference.FILTER_CUSTOM && type !== preference.FILTER_REALTIME &&
                                type !== preference.FILTER_PERIOD) {
                                continue;
                              }
                              if (first) {
                                selectedType = type
                                selectedName = filterKey;
                              }
                              first = false;
                              let is_default = safeDeepGetWithType(filter, [filterKey, 'is_default'], false);
                              if (!is_default) {
                                continue;
                              } else {
                                selectedType = type
                                selectedName = filterKey;
                                break;
                              }
                            }
                          }
                        }
                        if (selectedType === preference.FILTER_PERIOD || selectedType === preference.FILTER_REALTIME) {
                          _props.wSetEnv({
                            type: "params",
                            env: key,
                            value: { 'period': selectedName }
                          });
                        } else if (selectedType === preference.FILTER_CUSTOM) {
                          _props.wSetEnv({
                            type: "params",
                            env: key,
                            value: { 'start': preference.BEGINNING_OF_DAY, 'end': preference.NOW }
                          });
                        }
                      } else {
                        _props.wSetEnv({
                          type: "params",
                          env: key
                        });
                      }
                    }
                    let singleConfFinal = { ...initConf, ...singleConf }
                    _props.wSetConfig({
                      single_config: singleConfFinal,
                      background_config: backgroundConfig
                    });
                    _this.setState({ first: true, navDashboard })
                  }
                }
              }
            }
          }
        }
      }
    );
  }

  componentWillUnmount() {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    const wsKey = WKEY + '_' + navId;
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: wsKey });
  }

  handleRefresh() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const navId = safeDeepGetWithType(_props, ['id'], '');
    if (isNone(navId) || isEmpty(navId)) {
      return;
    }
    const listDash = safeDeepGetWithType(_state, ['navDashboard'], {});
    if (isEmpty(listDash)) {
      return;
    }
    for (let key in listDash) {
      _props.wSingleRequestCall({
        id: key
      });
    }
    _this.setState({ first: false })
  }

  handleDropdown(dashboardId, param) {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let devId = safeDeepGetWithType(param, ['deviceId'], '');
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'device_id': devId }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
    _props.wSetEnv({
      type: "body",
      env: buildCommandId(dashboardId),
      value: { 'device_id': devId }
    });
  }

  handleControl(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    const body = {};
    if (value !== null) {
      body.value = value;
    }
    _this.setState({
      event: 'control'
    })
    _props.wSingleRequestCall({
      id: buildCommandId(dashboardId),
      body
    });
  }

  handleUploadCsv(dashboardId, param) {
    const _props = this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    // TODO webservice upload CSV
  }

  handleDropdownCustom(dashboardId, params) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let devId = safeDeepGetWithType(params, ['deviceId'], '');
    let sensor = safeDeepGetWithType(params, ['sensor'], '');
    let config = safeDeepGetWithType(params, ['config'], '');
    let param = safeDeepGetWithType(params, ['param'], '');
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'device_id': devId, sensor, config, param }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
    _props.wSetEnv({
      type: "body",
      env: buildCommandId(dashboardId),
      value: { 'device_id': devId, sensor, config, param }
    });
  }

  handleControlCustom(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    const body = {};
    if (value !== null) {
      body.value = value;
    }
    _this.setState({
      event: 'control'
    })
    _props.wSingleRequestCall({
      id: buildCommandId(dashboardId),
      body
    });
  }

  handlePeriod(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let value = safeDeepGet(param, ['value']);
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { 'period': value }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
  }

  handlePeriodDate(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let start = safeDeepGet(param, ['start']);
    let end = safeDeepGet(param, ['end']);
    _props.wSetEnv({
      type: "params",
      env: dashboardId,
      value: { start, end }
    });
    _props.wSingleRequestCall({
      id: dashboardId
    });
  }

  handleDownload(dashboardId, param, isFromChart) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    let params = {};
    let type = safeDeepGetWithType(param, ['type'], preference.FILTER_PERIOD);
    if (type === preference.FILTER_PERIOD) {
      let value = safeDeepGetWithType(param, ['value'], '');
      params.period = value
    } else {
      let start = safeDeepGetWithType(param, ['start'], 0);
      let end = safeDeepGetWithType(param, ['end'], 0);
      params.start = start
      params.end = end
    }
    _this.setState({
      event: 'download',
      isFromChart: isFromChart,
    })
    _props.wSingleRequestCall({
      id: buildDownloadId(dashboardId),
      body: {},
      params
    });
  }

  handleSelectedDeviceId(body, dashboardsAffected) {
    const _props = this.props
    for (let i = 0; i < dashboardsAffected.length; i++) {
      _props.wSetEnv({
        type: "params",
        env: dashboardsAffected[i],
        value: body
      });
      _props.wSetEnv({
        type: "params",
        env: buildDownloadId(dashboardsAffected[i]),
        value: body
      });
      _props.wSingleRequestCall({
        id: dashboardsAffected[i]
      });
    }
  }

  handleSelector(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGetWithType(_props, ['id'], '');
    if (isNone(navId) || isEmpty(dashboardId)) {
      return;
    }
    let device_id = safeDeepGetWithType(param, ['value'], '');
    let dashboardsAffected = safeDeepGetWithType(_props, ['data', dashboardId + '_rpayload', 'affect'], []);
    const body = {
      device_id
    };
    _this.handleSelectedDeviceId(body, dashboardsAffected);
  }

  handleSelectFirstItem(dashboardId, param) {
    const _this = this
    const _props = _this.props
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId) || isEmpty(dashboardId)) {
      return;
    }
    let devices = safeDeepGetWithType(param, ['devices'], []);
    if (devices.length < 1) {
      return;
    }
    let device_id = safeDeepGetWithType(devices, [0, 'device_id'], '');
    let dashboardsAffected = safeDeepGetWithType(_props, ['data', dashboardId + '_rpayload', 'affect'], []);
    const body = {
      device_id
    };
    _this.handleSelectedDeviceId(body, dashboardsAffected);
  }

  resize(event) {
    this.setState({ event });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { first } = _state
    if (first) {
      _this.handleRefresh();
    }
    const navId = safeDeepGet(_props, ['id']);
    if (isNone(navId)) {
      return;
    }
    const wsKey = WKEY + '_' + navId;
    const conf_dashboard = safeDeepGetWithType(_props, ['conf_dashboard'], {});
    const config = safeDeepGetWithType(conf_dashboard, ['dashboard'], {});
    const data = safeDeepGetWithType(_props, ['data'], {});
    window.onresize = this.resize;
    const heights = window.screen.height * 90 / 100 - 176;
    const label = safeDeepGetWithType(_props, ['label'], '');
    const path = safeDeepGetWithType(_props, ['path'], '');
    let url = '';
    let isEmbedded = false;
    let _refresh_rate;
    // Handle embedded
    if (!isEmpty(conf_dashboard)) {
      const type = safeDeepGetWithType(conf_dashboard, ['type'], preference.DASHBOARD_BASIC);
      if (type === preference.DASHBOARD_EMBEDDED) {
        url = safeDeepGetWithType(conf_dashboard, ['custom_url'], 'google.com');
        isEmbedded = true;
      }
      _refresh_rate = safeDeepGetWithType(conf_dashboard, ['refresh'], 0)
    }
    const _var = safeDeepGetWithType(conf_dashboard, ['var'], {});
    const dash_view = safeDeepGetWithType(conf_dashboard, ['view'], {});
    if (isEmbedded) {
      // for Iframe
      return (
        <SizeMe>{({ size }) =>
          <div className="view" style={{ minWidth: '100%' }}>
            <SubViewHeaderWithTenantName title={label} path={path} hasRefresh={false} />
            <div className="view-content-dashboard" style={{ minWidth: '100%', padding: 0 }}>
              <Iframe url={url}
                width="100%"
                height={heights}
                id="myId"
              />
            </div>
          </div>
        }
        </SizeMe>
      );
    } else {
      return (
        <SizeMe>{({ size }) =>
          <div className="view" >
            <SubViewHeader {...this.props} title={label} path={path} hasRefresh={true} />
            <DynamicGridGenerator
              config={config}
              data={data}
              _var={_var}
              dash_view={dash_view}
              wsKey={wsKey}
              _refresh_rate={_refresh_rate}
              handleDropdown={this.handleDropdown}
              handleControl={this.handleControl}
              handleUploadCsv={this.handleUploadCsv}
              handleDropdownCustom={this.handleDropdownCustom}
              handleControlCustom={this.handleControlCustom}
              handlePeriod={this.handlePeriod}
              handlePeriodDate={this.handlePeriodDate}
              handleDownload={this.handleDownload}
              handleSelector={this.handleSelector}
              handleSelectFirstItem={this.handleSelectFirstItem}
              contentWidth={size.width}
              staticGrid={true}
              style={{ margin: 5 }}
            />
          </div>
        }
        </SizeMe>
      );
    }
  }
}

const mapStateToProps = function (state, ownProps) {
  const navId = safeDeepGet(ownProps, ['id']);
  if (isNone(navId)) {
    return {}
  }
  const wsKey = WKEY + '_' + navId;
  wSelector = buildWSelector(wsKey);
  wBoundActions = buildWBoundActions(wsKey);
  return {
    conf_dashboard: wSelector.getSoleInitMappedRPayload(state, 'conf_dashboard'),
    config: wSelector.getSoleInitMappedRPayload(state, 'conf_dashboard', 'dashboard'),
    label: wSelector.getSoleInitMappedRPayload(state, 'label'),
    path: wSelector.getSoleInitMappedRPayload(state, 'path'),
    data: wSelector.getMappedState(state)
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));